'use es6';

import { useEffect } from 'react';
const HOTJAR_SCRIPT_ID = 'hotjar-script';
const HOTJAR_APP_ID = 870059; // app.hubspot.com

const Hotjar = () => {
  useEffect(() => {
    if (!document.getElementById(HOTJAR_SCRIPT_ID)) {
      (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () {
          // eslint-disable-next-line prefer-rest-params
          (h.hj.q = h.hj.q || []).push(arguments);
        };
        h._hjSettings = {
          hjid: HOTJAR_APP_ID,
          hjsv: 6
        };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.id = HOTJAR_SCRIPT_ID;
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  }, []);
  return null;
};
export const HotjarTrigger = ({
  name
}) => {
  useEffect(() => {
    if (typeof window.hj === 'function') {
      window.hj('trigger', name);
    }
  }, [name]);
  return null;
};
export default Hotjar;